import { useNavigate } from 'react-router';

import { OneColumn } from 'components/page';
import { usePermissionsContext } from 'context/PermissionsContext';
import { LojaGrid, LojaGridFilter, LojaReport } from 'pages/cadastro/loja/components';

export function LojaListComp() {
    const navigate = useNavigate();
    const { hasPermission } = usePermissionsContext();

    return (
        <OneColumn
            title="Lojas"
            createButton={hasPermission(['LOJA_CADASTRAR'])}
            extraButtons={[
                {
                    title: 'Importar dados',
                    onClick: () => navigate('importacao'),
                    visible: hasPermission(['LOJA_ALTERAR']),
                },
                {
                    title: 'Gerenciar grupos econômicos',
                    onClick: () => navigate('/grupo-economico'),
                    visible: hasPermission(['GRUPO_ECONOMICO_VISUALIZAR']),
                },
            ]}
        >
            <LojaGridFilter />

            <LojaReport />

            <LojaGrid />
        </OneColumn>
    );
}
